import React from 'react';
import { Box, Typography } from '@mui/material';
import ValidData from './ValidData';

/**
 * Valid Data Page - Standalone route for system-wide valid data management
 * Previously a tab in the Admin component
 * Contains frame properties, lens properties, contact properties, treatments, etc.
 */
export default function ValidDataPage() {
  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
        Valid Data Configuration
      </Typography>
      <ValidData />
    </Box>
  );
}
